import React, { useState } from "react";
import Modal from "react-modal";
import styles from "./NovoReferenciaModal.module.css";
import { useNotification } from "../../hooks/useNotification";

const NovaReferenciaModal = ({ isOpen, onClose }) => {
  const initialState = {
    studentId: "",
    serviceType: "",
    amount: "",
    classe: "",
  };

  const [referenceData, setReferenceData] = useState(initialState);
  const { notifyError, notifySuccess } = useNotification();

  const handleCreateReference = async () => {
    if (
      !referenceData.studentId ||
      !referenceData.serviceType ||
      !referenceData.classe ||
      !referenceData.amount ||
      Number(referenceData.amount) <= 0
    ) {
      notifyError("⚠️ Preencha todos os campos obrigatórios com valores válidos.");
      return;
    }

    try {
      const response = await fetch("/api/referencias", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          codigo_aluno: referenceData.studentId,
          tipo_servico: referenceData.serviceType,
          valor: Number(parseFloat(referenceData.amount).toFixed(2)),
          classe: referenceData.classe,
          status: "pendente",
        }),
      });

      const data = await response.json();

      if (response.ok) {
        notifySuccess(data.message || "✅ Referência criada com sucesso!");
        handleCancel();
      } else {
        notifyError(data.message || "❌ Erro ao criar referência.");
      }
    } catch (err) {
      console.error("Erro ao criar referência:", err);
      notifyError("❌ Erro ao conectar ao servidor. Tente novamente.");
    }
  };

  const handleCancel = () => {
    setReferenceData(initialState);
    onClose();
  };

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={handleCancel}
      className={styles.filterModal}
      overlayClassName={styles.modalOverlay}
    >
      <h2>Gerar Referência</h2>
      <div className={styles.modalContent}>
        <label>
          Código do Aluno: <span className={styles.required}>*</span>
          <input
            type="text"
            placeholder="Ex: 20250003"
            value={referenceData.studentId}
            onChange={(e) =>
              setReferenceData({ ...referenceData, studentId: e.target.value })
            }
            className={styles.shortInput}
          />
        </label>

        <label>
          Tipo de Serviço: <span className={styles.required}>*</span>
          <select
            value={referenceData.serviceType}
            onChange={(e) =>
              setReferenceData({
                ...referenceData,
                serviceType: e.target.value,
              })
            }
            className={styles.shortInput}
          >
            <option value="">Selecionar</option>
            <option value="MATRICULA">Matrícula</option>
            <option value="UNIFORME">Uniforme</option>
            <option value="RENOVACAO">Renovação</option>
            <option value="CERTIFICADO">Certificado</option>
            <option value="DECLARACAO">Declaração</option>
          </select>
        </label>

        <label>
          Classe: <span className={styles.required}>*</span>
          <select
            value={referenceData.classe}
            onChange={(e) =>
              setReferenceData({ ...referenceData, classe: e.target.value })
            }
            className={styles.shortInput}
          >
            <option value="">Selecionar</option>
            {[...Array(12)].map((_, i) => (
              <option key={i + 1} value={i + 1}>{`${i + 1}ª Classe`}</option>
            ))}
          </select>
        </label>

        <label>
          Valor (MZN): <span className={styles.required}>*</span>
          <input
            type="number"
            placeholder="Ex: 1500"
            value={referenceData.amount}
            onChange={(e) =>
              setReferenceData({ ...referenceData, amount: e.target.value })
            }
            className={styles.shortInput}
          />
        </label>

        <div className={styles.buttonsContainer}>
          <button className={styles.applyFilter} onClick={handleCreateReference}>
            Criar Referência
          </button>
          <button
            className={styles.cancelButton}
            onClick={handleCancel}
            type="button"
          >
            Cancelar
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default NovaReferenciaModal;